import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// Register the required components
ChartJS.register(ArcElement, Tooltip, Legend);

const DoughnutChart = ({
  data = {},
  options = {},
  width = 150,
  height = 150,
}) => {
  return (
    <Doughnut
      width={width}
      height={height}
      className="chartjs-chart"
      data={data}
      options={options}
    />
  );
};

export default DoughnutChart;
